import React, { useEffect, useRef, useState } from 'react'
import styles from './Phase1.module.css'

import Image from '../../components/Image/Image'
import IconVolume from '../../../../../assets/icons/IconVolume'
import IconMale from '../../../../../assets/icons/IconMale'
import IconFemale from '../../../../../assets/icons/IconFemale'
import IconBack from '../../../../../assets/icons/IconBack'
import IconForward from '../../../../../assets/icons/IconForward'

import { getSoundDownloadUrl } from '../../components/Sound/Sound'

const CardWord = ({
    word,
    onCardClick,
}) => {
    return (
        <div
            onClick={onCardClick}
            className={styles.wordContainer}>
            <div className={styles.wordContainerUpper}>
                <IconVolume size={24} />
                <Image
                    imagePath={word.img_path}
                    size={'80%'} />
                {
                    word.gender === 'Male' ? <IconMale size={24} /> :
                        word.gender === 'Female' ? <IconFemale size={24} /> :
                            word.gender === 'Both' ?
                                <div style={{display:'flex', flexDirection: 'column',}}>
                                    <IconMale size={24} />
                                    <div style={{ height: '8px' }}/>
                                    <IconFemale size={24} />
                                </div> :
                                <div style={{ width: '24px' }} />
                }
            </div>
            <p className={styles.wordHebrew}>{word.vow}</p>
            <p className={styles.wordEnglish}>{word.eng}</p>
        </div>
    )
}

const Phase1 = ({
    words,
    onNextPhase
}) => {

    const mediaPlayer = useRef(new Audio())

    const [playingIndex, setPlayingIndex] = useState(0);
    const [startPlayingIndex, setStartPlayingIndex] = useState(0)
    const [lastPlayingIndex, setLastPlayingIndex] = useState(3);

    const [currPage, setCurrPage] = useState(1)
    const maxPages = useRef(words.length % 4 === 0 ? words.length / 4 : Math.ceil(words.length / 4))

    const [fadeOut, setFadeOut] = useState(false)

    useEffect(() => {
        playAudioStart(playingIndex)
    }, [playingIndex])

    const playAudioStart = (index) => {
        getSoundDownloadUrl(words[index].sound_path).then((url) => {
            const audio = new Audio(url)
            audio.addEventListener('ended', onAudioEndIndex)
            audio.play()
        })
    }

    const onAudioEndIndex = () => {
        if (playingIndex >= lastPlayingIndex || words.length <= playingIndex + 1)
            return
        setPlayingIndex(prevIndex => prevIndex + 1);
    }

    const handleCardClick = (path) => {
        getSoundDownloadUrl(path).then((url) => {
            mediaPlayer.current.src = url
            mediaPlayer.current.play();
        })
    }

    const playNextSection = () => {

        setFadeOut(true);
        setTimeout(() => {
            setCurrPage(prevPage => prevPage + 1)
            setStartPlayingIndex(prevIndex => prevIndex + 4)
            setLastPlayingIndex(prevIndex => prevIndex + 4)
            if (playingIndex <= lastPlayingIndex)
                setPlayingIndex(prevIndex => prevIndex + 1)
        }, 200)
        setTimeout(() => {
            setFadeOut(false)
        }, 400);
    }

    const previousSection = () => {
        setFadeOut(true);
        setTimeout(() => {
            if (startPlayingIndex - 4 < 0) return
            setCurrPage(prevPage => prevPage - 1)
            setStartPlayingIndex(prevIndex => prevIndex - 4)
            setLastPlayingIndex(prevIndex => prevIndex - 4)
        }, 200)
        setTimeout(() => {
            setFadeOut(false)
        }, 400);
    }

    return (
        <div className={styles.container}>
            <div
                className={styles.wordsContainer}
                style={{ opacity: fadeOut ? 0 : 1 }}>
                {
                    words.slice(startPlayingIndex, lastPlayingIndex + 1).map((word, index) => {
                        return <CardWord
                            key={String(index)}
                            shown={index + startPlayingIndex <= playingIndex}
                            onCardClick={() => handleCardClick(word.sound_path)}
                            word={word} />
                    })
                }
            </div>
            <div className={styles.bottomNavigation}>
                {currPage <= 1 ?
                    <div style={{ width: '40px' }} /> : <IconBack
                        size={24}
                        className={styles.backButton}
                        color={'black'}
                        onClick={() => previousSection()} />}
                <p className={styles.bottomNavigationTitle}>{(currPage) + '/' + (maxPages.current)}</p>
                {currPage >= maxPages.current ?
                    <div style={{ width: '40px' }} /> : <IconForward
                        size={24}
                        color={'white'}
                        className={styles.nextButton}
                        onClick={() => playNextSection()} />}
            </div>
            <p
                onClick={() => {/* if (playingIndex + 1 >= words.length)  */onNextPhase(); }}
                className={styles.testButton} style={playingIndex + 1 >= words.length ? {} : { opacity: 0.3 }}>Test</p>
        </div>

    )
}

export default Phase1
